export default function getSanitizedDiscount(value?: string): number {
    if (!value) return 0;

    const sanitized = value.replace('R$ ', '').replace(',', '.');

    return parseFloat(sanitized);
}
